<div class="component-container flex flex-col justify-center items-center">
  <div class="display-section flex flex-col justify-center items-center">
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          First Name
        </div>
        <div class="value w-3/5">
          {{ userDetails?.firstName }}
        </div>
      </div>
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
        <div class="label w-2/5">
          Last Name
        </div>
        <div class="value w-3/5">
          {{ userDetails?.lastName }}
        </div>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Email
        </div>
        <div class="value w-3/5">
          {{ userDetails?.emailId }}
        </div>
      </div>
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Username
        </div>
        <div class="value w-3/5">
          {{ userDetails?.username }}
        </div>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Date of Birth
        </div>
        <div class="value w-3/5">
          {{ userDetails?.dob | date }}
        </div>
      </div>
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Gender
        </div>
        <div class="value w-3/5">
          {{ userDetails?.gender?.value }}
        </div>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Role
        </div>
        <div class="value w-3/5">
          {{ rolesLabelMap[userDetails?.role] }}
        </div>
      </div>
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Phone Number
        </div>
        <div class="value w-3/5">
          {{ userDetails?.phoneNumber }}
        </div>
      </div>
    </div>
    <div
      *ngIf="userDetails['role'] != roles['superAdmin']"
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        *ngIf="userDetails?.role != roles?.superAdmin"
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Consent form
        </div>
        <div class="value w-3/5">
          <span
            (click)="userDetails['consentDate'] ? hippaConsentClicked() : {}"
            [class.link]="userDetails?.consentDate"
          >
          {{ userDetails?.consentDate ? 'View' : 'Not Completed' }}
           </span>
          <span
            (click)="triggerNotification('hippaConsent')"
            *ngIf="!userDetails?.consentDate && loggedInUserRole !=
            roles['adult'] && loggedInUserRole != roles['participant'] &&
            loggedInUserRole < userDetails?.role"
            class="link reminder-link"
          >
         Send Reminder
           </span>
        </div>
      </div>
      <div *ngIf="userDetails?.role === roles?.participant"
           class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Assent
        </div>
        <div class="value w-3/5">
          <span
            (click)="userDetails['assentDate'] ? hippaAssentClicked() : {}"
            [class.link]="userDetails?.assentDate"
          >
          {{ userDetails?.assentDate ? 'View' : 'Not Completed' }}
          </span>
          <span
            (click)="triggerNotification('hippaAssent')"
            *ngIf="!userDetails?.assentDate && loggedInUserRole !=
            roles.adult && loggedInUserRole != roles.participant &&
            loggedInUserRole < userDetails.role
            "
            class="link reminder-link"
          >
        Send Reminder
          </span>
        </div>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Status
        </div>
        <div class="value w-3/5">
          {{ userDetails?.status?.value || 'NA' }}
        </div>
      </div>
      <div
        *ngIf="userDetails?.role === roles?.participant"
        class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Avatar
        </div>
        <div class="value w-3/5">
          <div
            *ngIf="userDetails?.avatar?.url; else noData"
            class="profile-image flex flex-row justify-center items-center {{!userDetails?.avatar.url ? 'p-[1.5rem]' : 'p-0'}}"
          >
            <app-image
              [url]="userDetails['avatar'].url"
              class="h-[3.2rem] w-[3.2rem]"
            ></app-image>
          </div>
          <ng-template #noData>
            None
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div
    class="action-section flex flex-row justify-end items-center
    md:mr-[12rem] mr-[0] gap-[1.5rem]"
  >
    <div
      (click)="(!resetPasswordLoading ? resetPassword() : '')"
      *ngIf="hasUserId;else noUserId"
      class="mt-[1rem]"
    >
      <div class="row flex justify-center items-center gap-[1rem]">
        <mat-spinner
          *ngIf="resetPasswordLoading"
          [diameter]="20"
          mode="indeterminate"
          strokeWidth="2"
        />
        <span
          [class.clickable]="!resetPasswordLoading"
          [class.disabled]="resetPasswordLoading"
        >
          Reset Password
        </span>
      </div>
    </div>
    <ng-template #noUserId>
      <div
        (click)="openUpdatePasswordModalWindow()"
        class="clickable"
      >
        Update Password
      </div>
    </ng-template>
    <app-primary-button
      (handleClick)="editUserDetails()"
      class="edit-button w-[7.5rem]"
      type="small"
    >
      Edit
    </app-primary-button>
  </div>
</div>
